export enum ModuleBadge {
  SAT_DISCOUNT = 'SAT_DISCOUNT',
  PURCHASABLE = 'PURCHASABLE',
  RESERVATION = 'RESERVATION',
  IMMEDIATE_RESERVATION = 'IMMEDIATE_RESERVATION',
  WAITING_RESERVATION = 'WAITING_RESERVATION',
  EXCLUSIVE_PRICE = 'EXCLUSIVE_PRICE',
  OFFLINE_POINT = 'OFFLINE_POINT',
}
